/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import {
  Panel,
  PanelHeader,
  HeaderInfo,
  HeaderTitle,
  HeaderSubtitle,
  CloseButton,
  StopsSection,
  StopsSectionTitle,
  StopsList,
  StopItem,
  StopTimeline,
  StopDotWrapper,
  StopDot,
  PulseRing,
  StopLine,
  StopContent,
  StopName,
  StopTime,
  TimeStatusBadge,
  StopAddress,
  BusIconHeader,
} from "./styled";
import { MdClose, MdDirectionsBus } from "react-icons/md";

const ModalPonto = (props, { id = "modal", onClose = () => {} }) => {
  let [checkSet, setCheckSet] = useState(false);
  let max_size = sessionStorage.getItem("length"); // armazena o tamanho do intervalo de horários
  let array = [];
  let array2 = [];
  var diffHoraAtual;

  let _set = new Set([0]); // set remove horas duplicadas
  const timer = (bus_time, index) => {
    // captura tempo previsto para passagem de ônibus da api
    //:param bus_time (hora do onibus)
    //: index => index para remover duplicados
    if (bus_time) _set.add(bus_time);
    setTimeout(() => {
      if (Array.from(_set).length >= max_size) {
        setCheckSet(true);
      }
    }, 1000);
  };

  const subHour = (hora1, hora2) => {
    // subtrai hora 1 de hora 2
    let [horas, minutos, segundos] = hora2.split(":");

    // converte as horas para milissegundos
    let horaInicialMillis = horas * 60 * 60 * 1000;

    // converte os minutos para milissegundos
    let minutosMillis = minutos * 60 * 1000;

    // converte os segundos para milissegundos
    let segundosMillis = segundos * 1000;

    // calcula o total de milissegundos da hora inicial
    let totalMillisLastRealTime =
      horaInicialMillis + minutosMillis + segundosMillis;

    [horas, minutos, segundos] = hora1.split(":");

    // converte as horas para milissegundos
    horaInicialMillis = horas * 60 * 60 * 1000;

    // converte os minutos para milissegundos
    minutosMillis = minutos * 60 * 1000;

    // converte os segundos para milissegundos
    segundosMillis = segundos * 1000;

    // calcula o total de milissegundos da hora inicial
    let totalMillisShedule = horaInicialMillis + minutosMillis + segundosMillis;

    // subtrai hora atual programada com o real time
    return totalMillisShedule - totalMillisLastRealTime;
  };

  const somaPontos = (atrasoInicial, index) => {
    let [horas, minutos, segundos] = atrasoInicial.split(":");

    // converte as horas para milissegundos
    let horaInicialMillis = horas * 60 * 60 * 1000;

    // converte os minutos para milissegundos
    let minutosMillis = minutos * 60 * 1000;

    // converte os segundos para milissegundos
    let segundosMillis = segundos * 1000;

    // calcula o total de milissegundos da hora inicial
    let atraso = horaInicialMillis + minutosMillis + segundosMillis;

    // Cria um for para percorrer o array schedule_time a partir do index enviado
    for (let i = index; i < props.data.schedulePoint.stops.length; i++) {
      //salva em scheduleMilisegundos o calculo do atraso
      let scheduleMilisegundos =
        converterHorarioParaMilissegundos(
          props.data.schedulePoint.stops[i].schedule_time1
        ) + atraso;

      //armazena em schedule_time1 o horario formatado
      props.data.schedulePoint.stops[i].schedule_time1 =
        converterMilissegundosParaHorario(scheduleMilisegundos);
    }
  };

  function converterMilissegundosParaHorario(milissegundos) {
    let segundos = Math.floor(milissegundos / 1000);
    let horas = Math.floor(segundos / 3600);
    segundos -= horas * 3600;
    let minutos = Math.floor(segundos / 60);
    segundos -= minutos * 60;
    return (
      horas.toString().padStart(2, "0") +
      ":" +
      minutos.toString().padStart(2, "0") +
      ":" +
      segundos.toString().padStart(2, "0")
    );
  }

  function converterHorarioParaMilissegundos(hora) {
    let [horas, minutos, segundos] = hora.split(":");

    // converte as horas para milissegundos
    let horaInicialMillis = horas * 60 * 60 * 1000;

    // converte os minutos para milissegundos
    let minutosMillis = minutos * 60 * 1000;

    // converte os segundos para milissegundos
    let segundosMillis = segundos * 1000;

    // calcula o total de milissegundos da hora inicial
    let totalMillisLastRealTime =
      horaInicialMillis + minutosMillis + segundosMillis;

    return totalMillisLastRealTime;
  }

  const Hour = () => {
    if (props.data.schedulePoint.stops !== null)
      for (let i = 0; i < props.data.schedulePoint.stops.length; i++) {
        array.push(props.data.schedulePoint.stops[i].real_time);
      }
    for (let index = array.length; index > -1; index--) {
      if (array[index] != null && array[index - 1] == null) {
        array[index - 1] = "-";
      }
    }
    return array;
  };

  Hour();

  const checkTime = (index, atraso1) => {
    const data = new Date();
    const hora = data.getHours();
    const minutos = data.getMinutes();
    const segundos = data.getSeconds();
    const horaFormatada = hora.toString().padStart(2, "0");
    const minutosFormatados = minutos.toString().padStart(2, "0");
    const segundosFormatados = segundos.toString().padStart(2, "0");
    let horaAtual = `${horaFormatada}:${minutosFormatados}:${segundosFormatados}`;
    let scheduleTime1 = props.data.schedulePoint.stops[index].schedule_time1;

    //se nao tiver passado em nenhum ponto, o atraso será igual ao horário atual
    if (atraso1 == null || atraso1 === undefined) {
      let diff = converterHorarioParaMilissegundos(horaAtual);
      let totalMillisShedule1 = converterHorarioParaMilissegundos(
        props.data.schedulePoint.stops[0].schedule_time
      );
      atraso1 = diff - totalMillisShedule1;
      if (atraso1 < 0) {
        atraso1 = 0;
      }
    }

    if (scheduleTime1 == null || scheduleTime1 === undefined) {
      for (let i = index; i < props.data.schedulePoint.stops.length; i++) {
        let totalMillisShedule1 = converterHorarioParaMilissegundos(
          props.data.schedulePoint.stops[i].schedule_time
        );
        let somaDiff = atraso1 + totalMillisShedule1;
        props.data.schedulePoint.stops[i].schedule_time1 =
          converterMilissegundosParaHorario(somaDiff);
      }
    }

    if (horaAtual > scheduleTime1) {
      // subtrai hora atual de hora com atraso
      let seconds = subHour(horaAtual, scheduleTime1);
      let atrasoInicial = converterMilissegundosParaHorario(seconds);
      if (diffHoraAtual == null) {
        diffHoraAtual = atrasoInicial;
        // somar os pontos
        somaPontos(atrasoInicial, index);
      } else {
        // somar os pontos
        somaPontos(diffHoraAtual, index);
      }
    }
  };

  const atraso = () => {
    let atraso1;
    if (props.data.schedulePoint.stops !== null)
      for (let i = 0; i < props.data.schedulePoint.stops.length; i++) {
        if (props.data.schedulePoint.stops[i].real_time == null) {
          if (array[i] !== "-") {
            checkTime(i, atraso1);
            let [horas, minutos] =
              props.data.schedulePoint.stops[i].schedule_time1.split(":");
            array2.push(
              `${horas}:${minutos}`
            );
          } else {
            array2.push("-");
          }
        } else {
          let totalMillisRealTime = converterHorarioParaMilissegundos(
            props.data.schedulePoint.stops[i].real_time
          );
          let totalMillisShedule = converterHorarioParaMilissegundos(
            props.data.schedulePoint.stops[i].schedule_time
          );

          atraso1 = totalMillisRealTime - totalMillisShedule;

          let [horas, minutos] =
            props.data.schedulePoint.stops[i].real_time.split(":");
          array2.push(
            `${horas}:${minutos}r`
          );
        }
      }
    else {
      for (
        let index = 0;
        index < props.data.schedulePoint.poi.length;
        index++
      ) {
        array2.push(`${props.data.schedulePoint.poi[index].hour}`);
      }
    }
  };

  atraso();

  // Escape key handler
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") props.onClose();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  // Determine stop states for timeline rendering
  const getStopState = (index, totalStops) => {
    const hasStops = props.data.schedulePoint.stops !== null;
    if (!hasStops) return "default";

    const stops = props.data.schedulePoint.stops;
    const realTime = stops[index].real_time;
    const isLast = index === totalStops - 1;

    if (realTime !== null) {
      // Check if this is the LAST passed stop
      const nextHasRealTime = index + 1 < totalStops
        ? stops[index + 1].real_time !== null
        : false;
      if (!nextHasRealTime && !isLast) return "lastPassed";
      return "passed";
    }

    // Ponto não executado mas com pontos à frente já executados = pulado
    const hasLaterExecution = stops.slice(index + 1).some(s => s.real_time !== null);
    if (hasLaterExecution) return "skipped";

    // First null real_time after passed items = próximo ponto
    if (index > 0) {
      const prevHasRealTime = stops[index - 1].real_time !== null;
      if (prevHasRealTime) return "next";
      if (array[index] === "-") return "next";
    }

    if (isLast) return "lastStop";
    return "future";
  };

  // Compute time status for passed stops
  const getTimeStatus = (index) => {
    const hasStops = props.data.schedulePoint.stops !== null;
    if (!hasStops) return null;
    const stop = props.data.schedulePoint.stops[index];
    if (stop.real_time === null) return null;

    const realMs = converterHorarioParaMilissegundos(stop.real_time);
    const schedMs = converterHorarioParaMilissegundos(stop.schedule_time);
    const diffMs = realMs - schedMs;
    const toleranceMs = 3 * 60 * 1000; // 3 min tolerance

    if (diffMs > toleranceMs) return "late";
    if (diffMs < -toleranceMs) return "early";
    return "ontime";
  };

  const formatScheduleTime = (timeStr) => {
    if (!timeStr || timeStr === "-") return "";
    const parts = timeStr.split(":");
    return `${parts[0]}:${parts[1]}`;
  };

  const totalStops = props.data.schedulePoint.poi.length;

  // Build header info
  const lineName = props.data.locationsPoint?.name || "";
  const buslineshift = props.data.locationsPoint?.buslineshift;
  const shiftHour = buslineshift?.hour || "";
  const direction = buslineshift?.direction || "";
  const unitLabel = props.data.schedulePoint?.dev_status?.label2 || "";

  return (
    <Panel role="dialog" aria-modal="true" aria-label="Pontos de parada">
      <PanelHeader>
        <BusIconHeader>
          <MdDirectionsBus />
        </BusIconHeader>
        <HeaderInfo>
          <HeaderTitle>{lineName}</HeaderTitle>
          <HeaderSubtitle>
            {shiftHour}{direction ? ` - ${direction}` : ""}{unitLabel ? ` - ${unitLabel}` : ""}
          </HeaderSubtitle>
        </HeaderInfo>
        <CloseButton onClick={() => props.onClose()} aria-label="Fechar">
          <MdClose />
        </CloseButton>
      </PanelHeader>

      <StopsSection>
        <StopsSectionTitle>Pontos de parada</StopsSectionTitle>
      </StopsSection>

      <StopsList>
        {props.data.schedulePoint.poi.map((item, index) => {
          const state = getStopState(index, totalStops);
          const isLastItem = index === totalStops - 1;
          const timeStatus = getTimeStatus(index);

          // Get stop name
          let stopName = "";
          if (props.data.locationsPoint.poi) {
            const found = props.data.locationsPoint.poi.find(
              (l) => item.poi_id === l.id
            );
            if (found) stopName = found.name;
            // Also trigger timer for set dedup
            props.data.locationsPoint.poi.forEach((l, i) => {
              timer(item.hour, i);
            });
          }

          const scheduleTime = item.hour
            ? formatScheduleTime(item.hour)
            : "";
          const displayTime = array2[index] || "";
          const isRealTime = displayTime.endsWith("r");
          const cleanTime = isRealTime
            ? displayTime.slice(0, -1)
            : displayTime;

          const endereco = props.data.enderecos?.[index] || "";

          return (
            <StopItem key={index} state={state}>
              <StopTimeline>
                <StopDotWrapper>
                  <StopDot state={state} />
                  {state === "next" && <PulseRing />}
                </StopDotWrapper>
                {!isLastItem && <StopLine state={state} />}
              </StopTimeline>
              <StopContent>
                <StopName state={state}>{stopName}</StopName>
                <StopTime>
                  {state === "skipped" ? (
                    <>
                      <span>Previsto {scheduleTime}</span>
                      <TimeStatusBadge status="skipped">Não executado</TimeStatusBadge>
                    </>
                  ) : state === "passed" || state === "lastPassed" ? (
                    <>
                      <span>Previsto {scheduleTime}</span>
                      {isRealTime && (
                        <>
                          <span> - Chegou {cleanTime}</span>
                          {timeStatus && (
                            <TimeStatusBadge status={timeStatus}>
                              {timeStatus === "ontime"
                                ? "No horario"
                                : timeStatus === "late"
                                ? "Atrasado"
                                : "Adiantado"}
                            </TimeStatusBadge>
                          )}
                        </>
                      )}
                    </>
                  ) : cleanTime && cleanTime !== "-" ? (
                    <span>Previsao {cleanTime}</span>
                  ) : scheduleTime ? (
                    <span>Previsto {scheduleTime}</span>
                  ) : null}
                </StopTime>
                {endereco && <StopAddress>{endereco}</StopAddress>}
              </StopContent>
            </StopItem>
          );
        })}
      </StopsList>
    </Panel>
  );
};

export default ModalPonto;
